import { useMediaQuery, Theme } from '@material-ui/core';

export function useIsMobile() {
    return useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
}

export function useIsMediumDisplay() {
    return useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
}
